import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Similar to swatch but presents checkbox icon instead
 */
@Component({
    standalone: true,
    selector: 'loader',
    template: '',
    styleUrls: ['./loader.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {}
